export const RESPONDED_WITH_LABEL = 'Responded with';
export const RESPONDED_WITH_ANY_OF_LABEL = 'Responded with Any of';

export const MEMBER_RESPONDED_WITH_LABEL = 'Member Responded with';
export const MEMBER_RESPONDED_WITH_ANY_OF_LABEL = 'Member Responded with Any of';
